const commonSi = {
    "restaurant": "Restavracija",
    "restaurant_not_found": "Restavracija ni na voljo",
    "table_not_available": "Naročil za to mizo ni mogoče oddati.",
    "note": "Opomba",
    "order": "Naročilo",
    "internal_error": "Zahteva ni bila uspešna. Strežnik je odgovoril z naslednjo napako:",
    "no_results": "Ni rezultatov",
    "cancel": "Prekliči",
    "save": "Shrani",
    "back": "Nazaj",
    "search": "Iskanje",
    "search_for_file_names": "Iskanje imen datotek",
    "delete": "Izbriši",
    "search_by_restaurant": "Iskanje po restavraciji",
    "available": "Na voljo",
    "unavailable": "Ni na voljo",
    "name": "Ime",
    "status": "Stanje",
    "description": "Opis",
    "price": "Cena",
    "add": "Dodaj",
    "phone": "Telefon",
    "internal_server_error": "Notranja napaka strežnika",
    "remove_all": "Počisti vse",
    "settings": "Nastavitve",
    "restaurant_name": "Ime restavracije",
    "reservation_link": "Povezava za rezervacijo",
    "reservation_link_tooltip": "Dovoljene so samo povezave do rezervacijskega sistema Reservours",
    "add_user": "Dodaj uporabnika",
    "add_user_title": "Omogočite dostop do restavracije",
    "restaurant_users": "Uporabniki z dostopom do restavracije",
    "restaurant_description_hu": "Opis restavracije (madžarska)",
    "restaurant_description_en": "Opis restavracije (angleščina)",
    "changes_saved": "Spremembe so bile uspešno shranjene",
    "user_added_to_restaurant": "Uporabniku je bil odobren dostop do restavracije",
    "user_add_to_restaurant_tip": "Uporabnik z navedenim e-poštnim naslovom bo dobil dostop do izbrane restavracije. Če uporabnik še nima računa, bo dostop samodejno prejel po registraciji.",
    "sign_up_here": "Račun lahko ustvarite tukaj",
    "role_already_exists": "Uporabnik s tem e-poštnim naslovom že ima dostop do restavracije",
    "error": "Napaka",
    "header_image": "Slika glave",
    "upload_image": "Naloži sliko",
    "image_not_set": "Slika ni nastavljena",
    "validation": {
        "required": "To polje je obvezno",
        "optional": "To polje je neobvezno"
    },
    "hungary": "Madžarska",
    "date": "Datum",
    "close": "Zapri",
    "continue": "Nadaljuj",
    "select_image": "Izberite sliko",
    "grant": "Grant",
    "restaurant_settings": "Nastavitve restavracije",
    "create_restaurant": "Ustvari restavracijo",
    "restaurant_created": "Restavracija je bila uspešno ustvarjena",
    "restaurant_created_text": "Vaša restavracija je bila uspešno ustvarjena. Zdaj lahko dodajate jedi na jedilniku in upravljate nastavitve restavracije.",
    "continue_to_menu": "Nadaljuj z urejanjem menija",
    "languages": {
        "hu": "madžarščina",
        "en": "Angleščina",
        "de": "Nemščina",
        "fr": "Francoščina",
        "sk": "Slovaščina",
        "cz": "Češka",
        "pl": "poljščina",
        "si": "slovenščina",
        "hr": "hrvaščina",
        "ro": "Romunščina"
    },
    "no_file_selected": "Ni izbrane datoteke",
    "max_file_size": "Največja velikost datoteke:",
    "language": "Jezik",
    "google_analytics": "Google Analytics",
    "facebook_pixel": "Facebook Pixel",
    "analytic_integration_premium_feature": "Integracija analitike je del paketa PRO",
    "refresh": "Osveži",
    "address": "Naslov",
    "city": "Mesto",
    "postal_code": "Poštna številka",
    "timezone": "Časovni pas",
    "country": "Država",
    "currency": "Valuta",
    "currency_tooltip": "To je potrebno le za nastavitve profila, naš sistem ne bo izvajal finančnih transakcij v vašem imenu.",
    "or": "ali",
    "datachange_detected": "Zaznana sprememba podatkov",
    "datachange_subtitle": "Meni, ki ga urejate, se je od nalaganja strani spremenil.",
    "datachange_description": "Ali želite ponovno naložiti meni in izgubiti spremembe ali obdržati svojo različico in prepisati druge spremembe?",
    "datachange_refresh": "Ponovno naloži stran, izgubi moje spremembe",
    "datachange_overwrite": "Obdrži mojo različico, prepiši druge spremembe"
};

export default commonSi;
